import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExhibitorDirectoryRedirectGuard {
  constructor(private readonly router: Router, private readonly fairsFacade: DataAccessFairsFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.fairsFacade.fairId$.pipe(
      switchMap((fairId) =>
        this.router.navigate(['/fairs', fairId, 'exhibitors', 'letters'], {
          replaceUrl: true,
          queryParams: {
            character: 'A',
          },
        })
      )
    );
  }
}
